import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import useTopicKeywordSearch from "~/features/SearchV3/hooks/useTopicKeywordSearch";
import { useDisclosureStore } from "~/stores";

import NoTopicsMessage from "./NoTopicsMessage";
import TopicItem from "../SelectionColumns/TopicItem";
import { NormalizedDisclosure } from "~/types/search.types";

const KeywordTopicList = () => {
    const { language, filteredTopics, handleTopicClick } = useTopicKeywordSearch();
    const { t } = useTranslation();

    const selectedDisclosure = useDisclosureStore(state => state.disclosure);
    const disclosures = useDisclosureStore(state => state.disclosures);
    const isAllDisclosuresAvailable = useDisclosureStore(state => state.isAllDisclosuresAvailable);

    const renderFilteredTopics = useMemo(() => {
        const renderTopicItems = (disclosureId: number) => {
            return filteredTopics
                .filter(topic => topic.disclosureId === disclosureId)
                .map(topic => {
                    const key = `${disclosureId}-${topic.categoryId}-${topic.id}`;
                    return (
                        <TopicItem key={key} topic={topic} btnClickCallback={handleTopicClick} />
                    );
                });
        };

        const topicsByCategory = (disclosure: NormalizedDisclosure) => {
            const disclosureName = disclosure?.label[language];
            const topicsByDisclosure = renderTopicItems(disclosure.exploreId);

            return (
                <div className="p-1" key={disclosure.exploreId}>
                    <div className="h-9 p-2 text-sm text-stone-vibrant tracking-[-0.28px]">
                        {disclosureName}
                    </div>
                    {topicsByDisclosure}
                </div>
            );
        };

        return disclosures
            .filter(
                disclosure => isAllDisclosuresAvailable || selectedDisclosure?.id === disclosure.id
            )
            .map(disclosure => topicsByCategory(disclosure));
    }, [filteredTopics, selectedDisclosure, isAllDisclosuresAvailable]);

    const topicsItemsResult =
        filteredTopics.length === 0 ? (
            <NoTopicsMessage />
        ) : (
            <>
                <div className="flex items-center justify-between py-3 px-4 gap-2 text-sm text-stone-vibrant font-medium-light tracking-[-0.28px]">
                    <div>{t("searchForm.popup.topicLabel")}</div>
                    <div>{t("searchForm.popup.countResultsLabel")}</div>
                </div>

                {renderFilteredTopics}
            </>
        );

    return <div className="flex flex-col gap-1 overflow-y-auto">{topicsItemsResult}</div>;
};

export default KeywordTopicList;
